import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import { IssueBadge, RuleListStatus } from '@wix/rules-panel-ui';
import React, { useCallback } from 'react';
import { GroupLoadingSkeleton } from '../../group-loading-skeleton';
import { VerifyPageButton } from '../../verify-page-button';
export const useRuleGroupUtils = () => {
  const {
    t
  } = useTranslation();
  const getIssueCount = useCallback(rulesStateMap => {
    let issues = 0;
    rulesStateMap.forEach(ruleStatus => {
      var _ruleStatus$state;
      if ((ruleStatus == null || (_ruleStatus$state = ruleStatus.state) == null ? void 0 : _ruleStatus$state.status) === RuleListStatus.failed) {
        issues += 1;
      }
    });
    return issues;
  }, []);
  const getBadge = useCallback((isAnalyzeFailed, isAnalyzing, issueCount) => {
    if (isAnalyzeFailed) {
      return /*#__PURE__*/React.createElement(IssueBadge, {
        label: t('accessibility-wizard.rule-group.issue-count-badge.label.scan-failed')
      });
    }
    if (issueCount > 0 && !isAnalyzing) {
      return /*#__PURE__*/React.createElement(IssueBadge, {
        label: t('accessibility-wizard.rule-group.issue-count-badge.label', {
          numberOfIssues: issueCount
        })
      });
    }
    return undefined;
  }, [t]);
  const buildGroupNodes = useCallback((isFirstAnalysis, isAnalyzeFailed, isAnalyzing, props) => {
    const {
      numberOfIssues,
      pageId,
      taskCount,
      onClick
    } = props;
    const verifyButton = /*#__PURE__*/React.createElement(VerifyPageButton, {
      failedTaskCount: numberOfIssues,
      isLoading: isAnalyzing,
      pageId: pageId,
      taskCount: taskCount,
      onClick: onClick
    });
    let collapsedNode;
    if (isFirstAnalysis) {
      collapsedNode = /*#__PURE__*/React.createElement(GroupLoadingSkeleton, null);
    } else if (isAnalyzeFailed || isAnalyzing) {
      collapsedNode = /*#__PURE__*/React.createElement(Box, {
        padding: "0 3px"
      }, verifyButton);
    }
    return {
      collapsedNode,
      expandNode: verifyButton
    };
  }, []);
  return {
    buildGroupNodes,
    getBadge,
    getIssueCount
  };
};
//# sourceMappingURL=rule-group-utils.js.map